var React = require('react');

function Alert (props) {
    return React.createElement("svg",props,React.createElement("path",{"style":{"fill":"currentColor"},"d":"M11.667 10a1.667 1.667 0 11-3.334 0V5a1.667 1.667 0 013.334 0v5zM10 16.667a1.67 1.67 0 01-1.54-2.306A1.667 1.667 0 1110 16.667zM0 10c0 5.514 4.486 10 10 10s10-4.486 10-10S15.514 0 10 0 0 4.486 0 10z"}));
}

Alert.defaultProps = {"id":"Alert","viewBox":"0 0 20 20"};

module.exports = Alert;

Alert.default = Alert;
